import React from "react";
import styles from "./css/FranchiseType.module.css";
import CardSlider from "./CardFranchise/CardSlider";
import { Row, Col } from "react-bootstrap";
import { FaRegCheckCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function FranchiseType() {
 const navigate = useNavigate()
  return (
    <div className={styles.franchiseContainer}>
      <div style={{ width: "90%" }}>
        <h3 className={styles.heading}>Franchise Type</h3>
        <hr />
        <p
          style={{ maxWidth: "600px", textAlign: "center" }}
          className="mx-auto d-block"
        >
          It is a long established fact that a reader will be distracted by the
          readable content of a page when looking at its layout. The point of
          using Lorem Ipsum is that it has a more-or-less normal distribution of
          letters,
        </p>
        {/* <CardSlider/> */}
        <div
          style={{
            display: "flex",
            gap: "20px",
            width: "100%",
            padding: "20px",
            background: "#f5f5f5",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              flex: "1 1 300px",

              marginTop: 30,
              background: "white",
              borderRadius: "12px",
              padding: 20,
              boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
              minWidth: "250px",
              maxWidth: "350px",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
          >
            <h5
              style={{
                fontSize: "1.8rem",
                fontWeight: "800",
                letterSpacing: "1px",
              }}
            >
              Basic
            </h5>
            <h6>
              <span style={{ fontSize: 16, color: "#000", fontWeight: "600" }}>
                Rs
              </span>{" "}
              <sapn style={{ fontSize: 28, fontWeight: "700" }}>5000 /-</sapn>{" "}
            </h6>
            <div>
              <ul>
                <li style={{ fontSize: 14, marginTop: 10 }}>
                  It is a long established fact that a reader will be distracted
                  by the readable content of a page when looking at its layout
                </li>
                <li style={{ fontSize: 14, marginTop: 10 }}>
                  It is a long established fact that a reader will be distracted
                  by the readable content of a page when looking at its layout
                </li>
                <li style={{ fontSize: 14, marginTop: 10 }}>
                  It is a long established fact that a reader will be distracted
                  by the readable content of a page when looking at its layout
                </li>
              </ul>
            </div>
            <button
              style={{
                width: "100%",
                height: 45,
                borderRadius: 10,
                border: "none",
                marginTop: 20,
                backgroundColor: "#66D6FF",
                fontWeight: "700",
                fontSize: 16,
                color: "#fff",
              }}
              onClick={()=>navigate("/productDetail")}
            >
              Get Start
            </button>
          </div>

          <div
            style={{
              flex: "1 1 300px",

              background: "white",
              borderRadius: "12px",
              boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
              minWidth: "280px",
              maxWidth: "350px",
              padding: 20,
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              background: "linear-gradient(135deg, #ADE7FF, #6BCBFF)",
            }}
          >
            <h5
              style={{
                fontSize: "1.8rem",
                fontWeight: "800",
                letterSpacing: "1px",
              }}
            >
              Premium
            </h5>
            <h6>
              <span style={{ fontSize: 16, color: "#000", fontWeight: "600" }}>
                Rs
              </span>{" "}
              <sapn style={{ fontSize: 28, fontWeight: "700" }}>15000 /-</sapn>{" "}
            </h6>
            <div>
              <ul>
                <li style={{ fontSize: 15, marginTop: 10 }}>
                  It is a long established fact that a reader will be distracted
                  by the readable content of a page when looking at its layout
                </li>
                <li style={{ fontSize: 15, marginTop: 10 }}>
                  It is a long established fact that a reader will be distracted
                  by the readable content of a page when looking at its layout
                </li>
                <li style={{ fontSize: 15, marginTop: 10 }}>
                  It is a long established fact that a reader will be distracted
                  by the readable content of a page when looking at its layout
                </li>
              </ul>
            </div>
            <button
              style={{
                width: "100%",
                height: 45,
                borderRadius: 10,
                border: "none",
                marginTop: 20,
                backgroundColor: "#fff",
                fontWeight: "700",
                fontSize: 16,
                color: "#000",
              }}
               onClick={()=>navigate("/productDetail")}
            >
              Get Start
            </button>
          </div>

          <div
            style={{
              flex: "1 1 300px",
              marginTop: 30,
              background: "white",
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
              minWidth: "280px",
              maxWidth: "350px",
              padding: 20,
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
          >
            {/* <h2 style={{marginBottom: "10px"}}>Card Three</h2>
    <p>Cards scale and wrap nicely when viewed on smaller screens.</p> */}
            <h5
              style={{
                fontSize: "1.8rem",
                fontWeight: "800",
                letterSpacing: "1px",
              }}
            >
              Executive
            </h5>
            <h6>
              <span style={{ fontSize: 16, color: "#000", fontWeight: "600" }}>
                Rs
              </span>{" "}
              <sapn style={{ fontSize: 28, fontWeight: "700" }}>10000 /-</sapn>{" "}
            </h6>
            <div>
              <ul>
                <li style={{ fontSize: 14, marginTop: 10 }}>
                  It is a long established fact that a reader will be distracted
                  by the readable content of a page when looking at its layout
                </li>
                <li style={{ fontSize: 14, marginTop: 10 }}>
                  It is a long established fact that a reader will be distracted
                  by the readable content of a page when looking at its layout
                </li>
                <li style={{ fontSize: 14, marginTop: 10 }}>
                  It is a long established fact that a reader will be distracted
                  by the readable content of a page when looking at its layout
                </li>
              </ul>
            </div>
            <button
              style={{
                width: "100%",
                height: 45,
                borderRadius: 10,
                border: "none",
                marginTop: 20,
                backgroundColor: "#66D6FF",
                fontWeight: "700",
                fontSize: 16,
                color: "#fff",
              }}
              onClick={()=>navigate("/productDetail")}
            >
              Get Start
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
